import React from "react";
import { Modal } from "react-bootstrap";

class RentalResidentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedResidentId: props.rental?.resident_id || "",
      allocationType: props.rental?.allocation_type || "resident",
      floor: props.rental?.floor || "",
      room: props.rental?.room || "",
      showNewResidentForm: false,
      newResidentCivility: "M.",
      newResidentName: "",
      newResidentFirstName: "",
      isSubmitting: false,
    };
  }

  componentDidUpdate(prevProps) {
    // Réinitialiser le state quand la modal s'ouvre
    if (!prevProps.show && this.props.show && this.props.rental) {
      this.setState({
        selectedResidentId: this.props.rental.resident_id || "",
        allocationType: this.props.rental.allocation_type || "resident",
        floor: this.props.rental.floor || "",
        room: this.props.rental.room || "",
        showNewResidentForm: false,
        newResidentCivility: "M.",
        newResidentName: "",
        newResidentFirstName: "",
        isSubmitting: false,
      });
    }
  }

  handleResidentChange = (e) => {
    this.setState({ selectedResidentId: e.target.value });
  };

  handleAllocationTypeChange = (e) => {
    const newType = e.target.value;
    this.setState({
      allocationType: newType,
      selectedResidentId: newType === "resident" ? this.state.selectedResidentId : "",
    });
  };

  handleFloorChange = (e) => {
    this.setState({ floor: e.target.value });
  };

  handleRoomChange = (e) => {
    this.setState({ room: e.target.value });
  };

  toggleNewResidentForm = () => {
    this.setState((prevState) => ({
      showNewResidentForm: !prevState.showNewResidentForm,
      newResidentCivility: "M.",
      newResidentName: "",
      newResidentFirstName: "",
    }));
  };

  handleNewResidentSubmit = () => {
    const { newResidentCivility, newResidentName, newResidentFirstName } = this.state;
    const { rental, onAddResident } = this.props;

    if (!newResidentName.trim() || !newResidentFirstName.trim()) {
      return;
    }

    this.setState({ isSubmitting: true });

    const residentData = {
      sexe: newResidentCivility,
      name: newResidentName.trim().toUpperCase(),
      first_name: newResidentFirstName.trim(),
      establishment_id: rental.establishment_id || rental.establishment?._id,
    };

    onAddResident(residentData, (newResident) => {
      this.setState({
        showNewResidentForm: false,
        selectedResidentId: newResident._id,
        newResidentCivility: "M.",
        newResidentName: "",
        newResidentFirstName: "",
        isSubmitting: false,
      });
    });
  };

  handleSubmit = () => {
    const { selectedResidentId, allocationType, floor, room } = this.state;
    const { onConfirm } = this.props;

    this.setState({ isSubmitting: true });

    onConfirm({
      resident_id: allocationType === "resident" ? selectedResidentId : null,
      allocation_type: allocationType,
      floor: floor,
      room: room,
    });
  };

  getAvailableResidents = () => {
    const { residents, rental } = this.props;
    if (!residents || !rental) return [];

    const establishmentId = rental.establishment_id || rental.establishment?._id;
    return residents.filter(
      (r) => r.establishment_id === establishmentId || r.establishment_id?.toString() === establishmentId?.toString()
    );
  };

  render() {
    const { show, rental, isLoading, onClose } = this.props;
    const {
      selectedResidentId,
      allocationType,
      floor,
      room,
      showNewResidentForm,
      newResidentCivility,
      newResidentName,
      newResidentFirstName,
      isSubmitting,
    } = this.state;

    if (!show || !rental) return null;

    const availableResidents = this.getAvailableResidents();
    const productName = rental.product?.designation || "Produit";
    const establishmentName = rental.establishment?.name || "Établissement";
    const loading = isLoading || isSubmitting;

    const isFormValid = allocationType !== "resident" || (allocationType === "resident" && selectedResidentId);

    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop={loading ? "static" : true}
        keyboard={!loading}
        centered
        size="md"
        className="rental-resident-modal"
        dialogClassName="modal-dialog-rounded"
      >
        <Modal.Header className="rental-modal-header-gradient">
          <Modal.Title className="rental-modal-title">
            <i className="fas fa-user-edit"></i>
            Modifier le résident
          </Modal.Title>
          {!loading && (
            <button
              type="button"
              onClick={onClose}
              className="rental-validation-modal-close-btn"
            >
              <span>&times;</span>
            </button>
          )}
        </Modal.Header>

        <Modal.Body className="rental-modal-body">
          <div className="rental-modal-body-inner">
            <div className="rental-modal-product-section">
              <div className="rental-modal-product-label">
                Location :
              </div>
              <div className="rental-modal-product-name">{productName}</div>
              <div className="rental-modal-date-info">
                <strong>{establishmentName}</strong>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Type d'affectation */}
            <div className="col-12 mb-3">
              <label className="rental-modal-form-label">
                Type d'affectation
              </label>
              <select
                className="rental-modal-form-select"
                value={allocationType}
                onChange={this.handleAllocationTypeChange}
                disabled={loading}
              >
                <option value="resident">Résident</option>
                <option value="commun">Commun</option>
                <option value="tampon">Tampon</option>
              </select>
            </div>

            {/* Sélection du résident (uniquement si type = resident) */}
            {allocationType === "resident" && (
              <div className="col-12 mb-3">
                <div className="resident-selection-header">
                  <label className="rental-modal-form-label rental-modal-form-label-required">
                    Résident
                  </label>
                  <button
                    type="button"
                    className="resident-add-new-btn"
                    onClick={this.toggleNewResidentForm}
                    disabled={loading}
                  >
                    <i className="fas fa-plus"></i> Nouveau résident
                  </button>
                </div>

                {/* Formulaire nouveau résident */}
                {showNewResidentForm && (
                  <div className="new-resident-form">
                    <div className="new-resident-form-row">
                      <select
                        value={newResidentCivility}
                        onChange={(e) => this.setState({ newResidentCivility: e.target.value })}
                        disabled={loading}
                        className="new-resident-civility-select"
                      >
                        <option value="M.">M.</option>
                        <option value="Mme">Mme</option>
                      </select>
                      <input
                        type="text"
                        placeholder="Nom *"
                        value={newResidentName}
                        onChange={(e) => this.setState({ newResidentName: e.target.value.toUpperCase() })}
                        disabled={loading}
                        className="new-resident-name-input"
                      />
                      <input
                        type="text"
                        placeholder="Prénom *"
                        value={newResidentFirstName}
                        onChange={(e) => this.setState({ newResidentFirstName: e.target.value })}
                        disabled={loading}
                        className="new-resident-firstname-input"
                      />
                    </div>
                    <div className="new-resident-form-actions">
                      <button
                        type="button"
                        onClick={this.handleNewResidentSubmit}
                        disabled={loading || !newResidentName.trim() || !newResidentFirstName.trim()}
                        className="new-resident-submit-btn"
                      >
                        <i className="fas fa-check"></i> Créer
                      </button>
                      <button
                        type="button"
                        onClick={this.toggleNewResidentForm}
                        disabled={loading}
                        className="new-resident-cancel-btn"
                      >
                        <i className="fas fa-times"></i> Annuler
                      </button>
                    </div>
                  </div>
                )}

                {/* Dropdown sélection résident */}
                <select
                  className="rental-modal-form-select"
                  value={selectedResidentId}
                  onChange={this.handleResidentChange}
                  disabled={loading}
                >
                  <option value="">Sélectionner un résident</option>
                  {availableResidents.map((resident) => (
                    <option key={resident._id} value={resident._id}>
                      {resident.sexe} {resident.name} {resident.first_name}
                    </option>
                  ))}
                </select>
                {availableResidents.length === 0 && (
                  <div className="alert alert-info mt-2" role="alert">
                    <i className="fas fa-info-circle"></i> Aucun résident trouvé pour cet établissement. Créez-en un nouveau.
                  </div>
                )}
              </div>
            )}

            {/* Localisation */}
            <div className="col-6 mb-3">
              <label className="rental-modal-form-label">
                Étage
              </label>
              <input
                type="text"
                className="rental-modal-form-input"
                value={floor}
                onChange={this.handleFloorChange}
                placeholder="Ex: 2"
                disabled={loading}
              />
            </div>
            <div className="col-6 mb-3">
              <label className="rental-modal-form-label">
                Chambre
              </label>
              <input
                type="text"
                className="rental-modal-form-input"
                value={room}
                onChange={this.handleRoomChange}
                placeholder="Ex: 205"
                disabled={loading}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="rental-modal-footer">
          <button
            onClick={onClose}
            disabled={loading}
            className="rental-modal-btn-cancel"
          >
            Annuler
          </button>
          <button
            onClick={this.handleSubmit}
            disabled={loading || !isFormValid}
            className={`rental-modal-btn-primary ${
              loading || !isFormValid
                ? "rental-modal-btn-primary-disabled"
                : "rental-modal-btn-primary-enabled"
            }`}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span>Enregistrement...</span>
              </>
            ) : (
              <>Enregistrer</>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RentalResidentModal;
